<template>
  <footer>
    <div class="row align-items-center">
      <div class="col-12">
        <div class="row my-3 justify-content-center">
          <div class="col-auto">
              <div class="text-xs text-center me-2">
                <a
                  href="https://static-docs.shareguard.health/pages/ft-terms/en/"
                  class="text-muted"
                  target="_blank"
                >Terms & Conditions</a>
              </div>
          </div>
          <div class="col-auto">
              <div class="text-xs text-center me-2">
                <a
                  href="https://static-docs.shareguard.health/pages/ft-privacy/en/"
                  class="text-muted"
                  target="_blank"
                >Privacy Policy</a>
              </div>
          </div>
          <div class="col-auto">
              <div class="text-xs text-center me-2">
                <a
                  href="https://static-docs.shareguard.health/pages/ft-faq/en/"
                  class="text-muted"
                  target="_blank"
                >FAQ</a>
              </div>
          </div>
          <div class="col-auto">
            <div class="text-xs text-center me-2">
              <a
                href="https://static-docs.shareguard.health/pages/ft-about/en/"
                class="text-muted"
                target="_blank"
              >About</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <div class="text-xs text-center copyright text-muted text-start">
            Shareguard © {{ new Date().getFullYear() }},
            made with <i class="fa fa-heart text-muted"></i> by
            <a
              href="https://www.hygiaso.ch"
              class="font-weight-bold text-muted"
              target="_blank"
            > Hygiaso</a
            >
        </div>
      </div>

    </div>
</footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.nav-footer {
  line-height: 0.8;
}
</style>

